import { purchaseOrderStatus } from "data/constant/purchase-order-status";
import { purchaseOrderProducts } from "data/constant/purchase-order-products";

export const initialFilterState = () => {
  return {
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "orderId",
    order: "desc",
    status: {
      isSelectedAll: true,
      value: purchaseOrderStatus.map((option) => option.value),
    },
    productCode: {
      isSelectedAll: true,
      value: purchaseOrderProducts.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
